import { useState } from "react";
import { uid } from "../../lib/model";

const SINGLE = ["point", "text", "anomaly"];

function constrain(d) {
  const dx = d.x2 - d.x1;
  const dy = d.y2 - d.y1;
  if (d.type === "hline" || d.type === "axisX") return { ...d, y2: d.y1 };
  if (d.type === "vline" || d.type === "axisY" || d.type === "axisZ") return { ...d, x2: d.x1 };
  if (d.type === "dline") {
    const m = Math.max(Math.abs(dx), Math.abs(dy));
    return { ...d, x2: d.x1 + Math.sign(dx || 1) * m, y2: d.y1 + Math.sign(dy || 1) * m };
  }
  return d;
}

export function useDrawing({ svgRef, tool, color, width, label, fs = 1, onAdd }) {
  const [draft, setDraft] = useState(null);

  const toPt = (e) => {
    const svg = svgRef.current;
    const pt = svg.createSVGPoint();
    pt.x = e.clientX;
    pt.y = e.clientY;
    const r = pt.matrixTransform(svg.getScreenCTM().inverse());
    return { x: Math.round(r.x * 10) / 10, y: Math.round(r.y * 10) / 10 };
  };

  const onPointerDown = (e) => {
    if (tool === "select") return;
    const p = toPt(e);
    const shape = { id: uid(), type: tool, x1: p.x, y1: p.y, x2: p.x, y2: p.y, color, width, text: label, fs };
    if (SINGLE.includes(tool)) {
      onAdd(shape);
      return;
    }
    e.currentTarget.setPointerCapture?.(e.pointerId);
    setDraft(shape);
  };

  const onPointerMove = (e) => {
    if (!draft) return;
    const p = toPt(e);
    setDraft((d) => constrain({ ...d, x2: p.x, y2: p.y }));
  };

  const onPointerUp = () => {
    if (!draft) return;
    if (Math.hypot(draft.x2 - draft.x1, draft.y2 - draft.y1) > 3) onAdd(draft);
    setDraft(null);
  };

  return { draft, handlers: { onPointerDown, onPointerMove, onPointerUp, onPointerLeave: onPointerUp } };
}
